import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from 'app-services-library';
import * as i3 from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

class EfilingVersionStatusService {
    constructor(http) {
        this.http = http;
    }
    getEfilingVersionStatus(visatype) {
        return this.http.get(`/efiling/${visatype}`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
}
EfilingVersionStatusService.ɵfac = function EfilingVersionStatusService_Factory(t) { return new (t || EfilingVersionStatusService)(i0.ɵɵinject(i1.HttpClient)); };
EfilingVersionStatusService.ɵprov = i0.ɵɵdefineInjectable({ token: EfilingVersionStatusService, factory: EfilingVersionStatusService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EfilingVersionStatusService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function EfilingVersionStatusComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "b");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " and released date ");
    i0.ɵɵelementStart(5, "b");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7, ".\n");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.efilingVersionData == null ? null : ctx_r0.efilingVersionData.name, " latest version is ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\u00A0\u00A0", ctx_r0.efilingVersionData == null ? null : ctx_r0.efilingVersionData.latestVersion, "\u00A0\u00A0 ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("\u00A0\u00A0", ctx_r0.efilingVersionData == null ? null : ctx_r0.efilingVersionData.releaseDate, "\u00A0\u00A0");
} }
class EfilingVersionStatusComponent {
    constructor(efilingVersionStatusService, appServicesLibraryService) {
        this.efilingVersionStatusService = efilingVersionStatusService;
        this.appServicesLibraryService = appServicesLibraryService;
    }
    ngOnInit() {
        if (this.inputData) {
            const visatype = this.inputData.caseType === "I129EFILING" ? this.inputData.caseType : this.inputData.immigrationClassification ? this.inputData.immigrationClassification : this.inputData.visatype;
            this.efilingVersionStatusService.getEfilingVersionStatus(visatype)
                .pipe(take(1))
                .subscribe((response) => {
                if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                    this.efilingVersionData = response.data;
                }
            });
        }
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
}
EfilingVersionStatusComponent.ɵfac = function EfilingVersionStatusComponent_Factory(t) { return new (t || EfilingVersionStatusComponent)(i0.ɵɵdirectiveInject(EfilingVersionStatusService), i0.ɵɵdirectiveInject(i2.AppServicesLibraryService)); };
EfilingVersionStatusComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EfilingVersionStatusComponent, selectors: [["lib-efiling-version-status"]], inputs: { inputData: "inputData" }, decls: 1, vars: 1, consts: [["class", "row efilingStatus common-bene-class-for-translation", 4, "ngIf"], [1, "row", "efilingStatus", "common-bene-class-for-translation"]], template: function EfilingVersionStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EfilingVersionStatusComponent_div_0_Template, 8, 3, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.efilingVersionData == null ? null : ctx.efilingVersionData.latestVersion);
    } }, directives: [i3.NgIf], styles: [".efilingStatus[_ngcontent-%COMP%]{color:#000;font-weight:400;width:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EfilingVersionStatusComponent, [{
        type: Component,
        args: [{
                selector: 'lib-efiling-version-status',
                templateUrl: './efiling-version-status.component.html',
                styleUrls: ['./efiling-version-status.component.scss']
            }]
    }], function () { return [{ type: EfilingVersionStatusService }, { type: i2.AppServicesLibraryService }]; }, { inputData: [{
            type: Input
        }] }); })();

class EfilingVersionStatusModule {
}
EfilingVersionStatusModule.ɵfac = function EfilingVersionStatusModule_Factory(t) { return new (t || EfilingVersionStatusModule)(); };
EfilingVersionStatusModule.ɵmod = i0.ɵɵdefineNgModule({ type: EfilingVersionStatusModule });
EfilingVersionStatusModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            BrowserModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(EfilingVersionStatusModule, { declarations: [EfilingVersionStatusComponent], imports: [BrowserModule], exports: [EfilingVersionStatusComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EfilingVersionStatusModule, [{
        type: NgModule,
        args: [{
                declarations: [EfilingVersionStatusComponent],
                imports: [
                    BrowserModule
                ],
                exports: [EfilingVersionStatusComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of efiling-version-status
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EfilingVersionStatusComponent, EfilingVersionStatusModule, EfilingVersionStatusService };
//# sourceMappingURL=efiling-version-status.js.map
